









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'
import {InputMotoristaCancelamentoCargaSchema} from '@/schema/resource/MotoristaCancelamentoCarga/InputMotoristaCancelamentoCargaSchema'

@Component
export default class PersistMotoristaCancelamentoCargaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMotoristaCancelamentoCargaSchema()
  motoristaCancelamentoCarga = new MotoristaCancelamentoCarga()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.motoristaCancelamentoCarga.getMotoristaCancelamentoCarga(id)
    }

    $.await.done('getMotoristaCancelamentoCarga')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.motoristaCancelamentoCarga.persistMotoristaCancelamentoCarga()
    await Helper.successAndPush(
      'system.success.persist',
      '/motorista-cancelamento-carga/list'
    )
  }
}
